$.fn.dashboardFeedback = function () {
  function isInDashboardFeedbackPage() {
    return $("#transaction-dashboard-page").length > 0;
  }

  var $self = $(this);

  if (isInDashboardFeedbackPage()) {
    var $element = $(
      '<div class="feedbackArea visually-hidden" id="feedbackArea">\
                          <div class="feedbackBox">\
                          <a id="feedback" href="#">Please give your feedback about this feature </a>\
                          </div>\
                          </div>',
    );
    $("#content").after($element);
    $("#feedbackArea").removeClass("visually-hidden");
    $("#feedback").click(function (event) {
      event.preventDefault();
      $("#feedbackForm").removeClass("visually-hidden");
      $("#feedbackArea").addClass("visually-hidden");
      //                $('#feedbackForm').css('display', 'inline-block');
    });

    $("#feedbackClose").click(function (event) {
      event.preventDefault();
      $("#feedbackForm").addClass("visually-hidden");
      $("#feedbackArea").removeClass("visually-hidden");
      //                $('#feedbackForm').css('display', 'inline-block');
    });

    $("#feedbackSend").click(function (event) {
      event.preventDefault();
      var feedbackComment = $("#feedbackComment").val();
      if (
        !$("#feedbackLike").is(":checked") &&
        !$("#feedbackDislike").is(":checked")
      ) {
        // validation : like/dislike is mandatory
        $("#feedbackStatus").text(
          "Sorry, we're unable to send your message as you haven't given us any information",
        );
        return;
      }
      var feedbackURL = "/transactions/feedback.json";

      var feedbackRequest = {
        likeOrDislike: $("#feedbackLike").is(":checked"),
        feedbackComment: feedbackComment,
      };

      $.ajax({
        type: "POST",
        data: feedbackRequest,
        dataType: "JSON",
        url: feedbackURL,
        // data: URLS.data
      }).done(function (response) {
        if (response.status == "success") {
          $("#feedback").text(response.message);
          $("#feedback").replaceWith(
            $(
              '<div class="feedback-bottom">' +
                $("#feedback").html() +
                "</div>",
            ),
          );
          $("#feedbackClose").trigger("click");
        } else {
          $("#feedbackStatus").text(response.message);
        }
      });
    });
  }
};
